import { isAddress, isHexStrict } from 'web3-utils';
import { checkAddressChecksum, toChecksumAddress } from 'web3-utils'


// Initialize the wrapper
const initAssetWrapper = async (assetWrapperContract, user) => {
  assetWrapperContract.methods
    .initializeBundle(user.attributes.ethAddress)
    .send({ from: user.attributes.ethAddress })
    .then((result) => {
      console.log(result, "result");
      assetWrapperContract.once("Transfer", {}, function (error, event) {
        console.log("======", event.returnValues.tokenId);
        return;
      });
    })
    .catch((err) => {
      console.log(err, "err");
    });
};

export { initAssetWrapper };

export function search(nameKey, myArray){
  for (var i=0; i < myArray.length; i++) {
      if (myArray[i].chainId === nameKey) {
          return myArray[i];
      }
  }
};

export const isValidAddress = (address) => {
  if (address) {
    // `isAddress` do not require the string to start with `0x`
    // `isHexStrict` ensures the address to start with `0x` aside from being a valid hex string
    return isHexStrict(address) && isAddress(address)
  }

  return false
};

export const checksumAddress = (address) => {
  if (!isValidAddress(address)) {
    return ''
  }

  try {
    return toChecksumAddress(address)
  } catch (err) {
    return ''
  }
}